<template>
  <div>
    <div id ="popup_mask" ></div> <!-- 팝업 배경 DIV -->
    <div id="popupDiv"> <!-- 팝업창 -->
      <div class="pop_tit">
        <h2>
          파티원 추가
          <i onclick="popClose();" class="back fas fa-times"></i>
        </h2>
        <p>
          휴대폰 번호로 파티를 추가할 수 있습니다.<br>
          닉네임, 추천인 코드로도 추가할 수 있습니다.
        </p>
      </div>
      <div class="search">
        <div class="ul_menu_div">
          <ul class="menu_ul">
            <li onclick="search_type(1,'tel');" id="tel_search">휴대폰 번호</li>
            <li onclick="search_type(2,'name');" id="name_search">닉네임</li>
            <li onclick="search_type(3,'code');" id="code_search">추천인코드</li>
          </ul>
        </div>
        <div class="input_div">
          <input type="button" name="" value="검색">
          <label for=""></label>
          <input type="text" name="" value="">
        </div>
      </div>

      <div class="search_list">

        <!-- user -->
        <div class="party_member_div">
          <div onclick="location_user_info();" class="member_img" style="background-image:url(images/basic/img/profile2.png)"></div>
          <div class="member_info">
            <p class="member">
              <span id="thehae">Lv.7</span> <span class="name">천사같은채린</span>
              <img onclick="confirm_pop('천사같은채린');" src="images/basic/icon/add.svg" alt="">
            </p>
          </div>
        </div>

        <!-- user -->
        <div class="party_member_div">
          <div onclick="location_user_info();" class="member_img" style="background-image:url(images/basic/img/profile2.png)"></div>
          <div class="member_info">
            <p class="member">
              <span id="thehae">Lv.7</span> <span class="name">천사같은채린</span>
              <img onclick="confirm_pop('천사같은채린');" src="images/basic/icon/add.svg" alt="">
            </p>
          </div>
        </div>


      </div>
    </div>  
  </div>  
</template>

<script>
export default {
  mounted() {
    search_type(1,'tel');
    function search_type(n, type){
      var tag = window.$('.input_div').find('label');
      var val = window.$('.input_div').find('input[type=text]');
      if(type == 'tel'){
        tag.text('휴대폰 번호');
        val.attr('name', 'tel');
      }
      if(type == 'name'){
        tag.text('닉네임');
        val.attr('name', 'name');
      }
      if(type == 'code'){
        tag.text('추천인코드');
        val.attr('name', 'code');
      }
      window.$('.menu_ul').find('li').css('color', '#9EA3AB');
      window.$('.menu_ul').find('li').eq(n-1).css('color', '#FF7100');
      window.$('.menu_ul').find('li').css('border', '0.267vw solid #DDE0E4');
      window.$('.menu_ul').find('li').eq(n-1).css('border', '0.267vw solid #FF7100');
      window.$('.menu_ul').find('li').eq(n-1).css('color', '#FF7100');
      window.$('.menu_ul').find('li').eq(n).css('border-left', '0.267vw solid #FF7100');
    }
  },
}
</script>

<style>

</style>